import { render, staticRenderFns } from "./Skupovi.vue?vue&type=template&id=72292c10&scoped=true&"
import script from "./Skupovi.vue?vue&type=script&lang=js&"
export * from "./Skupovi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72292c10",
  null
  
)

export default component.exports